import React from 'react';
import { Table, FormGroup } from 'reactstrap';
import '../stylesheets/custom.css';
import { CompanyRow } from './CompanyRow';

export function CompaniesTable({
    allCompanies,
    onFeatureToggle   // New prop: callback when checkbox changes
}) {
    return (
        <FormGroup check>
            <h3 className='table-header'>All Companies</h3>
            <Table striped>
                <thead>
                    <tr>
                        <th></th>
                        <th>Company ID</th>
                        <th>Company</th>
                        <th>Feature Access</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        allCompanies.map(c => {
                            return (
                                <CompanyRow
                                    key={c.id}
                                    company={c}
                                    onFeatureToggle={onFeatureToggle}   // Pass down the handler
                                />
                            )
                        })
                    }
                </tbody>
            </Table>
        </FormGroup>
    );
}